<template>
  <div>
    <tr
      v-for="(hour, hourIndex) in lastRowHours"
      :key="hourIndex + hour"
      :data-rowhour="hour"
      :style="boxHeight"
      class="last-row"
    >
      <td :class="$isMobile ? 'td--first--mobile' : ''"></td>
      <td
        v-for="(rowNum, rowNumIndex) in nrColumns"
        :key="rowNumIndex + hour"
        class="each-day last-hour"
        :class="isPastLastHour(rowNum) ? 'past-day' : ''"
        :data-daynum="rowNum"
      >
        <PastSlot v-if="isPastLastHour(rowNum)" />
      </td>
    </tr>
  </div>
</template>

<script>
import PastSlot from "./PastSlot";

// const FIFTEEN_MINUTES = 900000; 
const ONE_DAY = 86400000;

export default {
  name: "LastHourRows",
  data() {
    return {
      // Else, when midnight hits, monday column has two gaps (0:15, 0:30)
      // whereas tuesday already shows 0:00 as past, e.g. a gap in experience
      lastRowHours: ["00:00", "00:00", "00:00"],
      // lastRowHours: ["00:00", "00:15", "00:30"],
    };
  },
  props: [
    "boxHeight",
    "week",
    "viewStartMS",
    "lastMinMS",
  ],
  components: {
    PastSlot,
  },
  computed: {
    nrColumns() {
      return this.week ? 7 : 1;
    },
  },
  // set timer interval to update what's in the past and what's not
  methods: {
    isPastLastHour(i) {
      const date = this.viewStartMS + i*ONE_DAY; // + hourIndex*FIFTEEN_MINUTES;
      const now = this.lastMinMS ? this.lastMinMS : Date.now();
      if (now > date) return true;
      return false;
    },
  },
};
</script>
<style scoped>
.each-day:hover .highlight-container {
  display: flex;
  /* z-index: 999; */
}

.each-day {
  background-color: transparent;
}

.past-day {
  /* background-color: #f9f9f9; */
  /* background-color: #f9fafa; */
  background-color: #fff;
}
</style>